import { render } from "./register.vue?vue&type=template&id=9a55a74a&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=9a55a74a&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a55a74a"]])

export default __exports__